// Begins with one non-whitespace character
// then zero or more chars that are non-special characters
const fullNameRE = /\S+\s\S+/;

/**
 * Returns name format rule
 */
 export const fullNameFormat = () => {
  return fullNameRE;
};

/**
 * Returns full name min length rule
 */
export const fullNameMinLength = () => {
  return 3;
};
